const storage = {
    not_configured: 'O provedor de armazenamento não está configurado.',
    missing_parameter: 'Parâmetro {{parameter}} ausente para o provedor de armazenamento.',
    upload_error: 'Falha ao fazer upload do arquivo para o provedor de armazenamento.',
    download_error: 'Failed to download file from the storage provider.',
};
export default Object.freeze(storage);
